import useListIndexed from './useListIndexed'
import useSandreList from './useSandreList'

const useSandreListIndexed = (field, key = 'code') => {
    const sandreList = useSandreList(field)
    return useListIndexed(sandreList, key)
}

export default useSandreListIndexed